export default {
    text: {
        language: '影片语言',
        save: '保存',
        ok: '好',
        cancel: '取消',
        abort: '放弃',
        error: '错误',
        close: '关闭',
        invalid: '无效的',
        pleaseSelect: '请选择',
        other: '其他',
        all: '全部',
        none: '无',
        name: '名称',
        balance: '花瓣余额',
        getReward: '获取奖励',
        petal: '花瓣',
        type: '类型',
        cost: '花费',
        effects: '效果',
        delete: '删除',
        confirm: '确认',
        deleteConfirmText: '确认删除?',
        deleteSuccess: '删除成功!',
        deleteFail: '删除失败!',
        tips: '提示',
        admin: '管理员',
        home: '首页',
        mine: '我的'
    },
    language: {
        en: '英文',
        cn: '中文',
        tc: '繁體中文',
        sc: '简体中文',
        mandarin: '中文(普通话)',
        cantonese: '中文(广东话)',
        language: '语言切换'
    },
    home: {
        downloadAlert: 'Petal安卓应用已经开放使用，下载请点击',
        here: '这里',
        downloadTitle: '下载Petal安卓应用',
        scanQRCode: '扫描下面二维码下载应用',
        scanWXQRCode: '扫码查看微信公众号',
        talkAbout: '和大家一起讨论剧情',
        backToTop: '回到页面顶部',
        downloadFrom: '从谷歌应用商店下载',
        orClick: '或者点击',
        downloadDirectly: '直接下载。',
        notLoggedIn: '您尚未登陆,',
        login: '登陆',
        getReward: '获得花瓣',
        getDaliyAndReferralReward: '获得每日奖励{daily}花瓣(上一次和本次领奖期间，一共获得{referral}花瓣的邀请人分红奖励)',
        expMore: '后可以享用更多功能',
        invitePeople: '邀请赚花瓣',
        inviteMsg: '邀请你加入Petal',
        inviteDscription: '邀请他人成为用户，邀请人和被邀请人都能获得额外奖励（20%的额外每日奖励，5%的额外被打赏分红）',
        copy: '复制',
        close: '关闭',
        cancel: '取消',
        version: '版本',
        about: '关于',
        sendFeedback: '问题反馈',
        feedbackToFB: '使用 Facebook 反馈',
        feedbackToEMail: '使用 E-mail 反馈',
        dailyReward: '每日签到赚花瓣',
        logout: '退出登录',
        introduction: 'Petal是一个视频分享社区。在这里我们鼓励用户分享视频，以及对优质的视频内容进行打赏。 ',
        giftSpec: '【Petal礼物说明】',
        devlopedBy: '本产品由Petal Network社区研发',
        finsh: '完成',
        skip: '跳过'
    },
    map: {
        name: '新冠分布图',
        title: '新冠即时数据',
        region: '地区',
        cases: '确诊',
        deaths: '死亡',
        newCases: '新增确诊',
        newDeaths: '新增死亡',
        deathRate: '死亡率',
        R0: '趋势'
    },
    video: {
        name: '视频',
        notSupportVideoType: '无法分享该视频源 (当前仅支持Youtube/Bilibili/腾讯视频分享).',
        share: '分享',
        shareVideoSucc: '分享视频成功!',
        shareVideoFail: '分享视频失败!',
        donateClickAgain: '再次点击进行打赏',
        likeConfirm: '确定是否给该视频打赏',
        reduceConfirm: '确定是否给该视频扣除',
        donateToVideoSucc: '给视频打赏成功!',
        reduceVideoPetalSucc: '给视频扣分成功!',
        donateToVideoFail: '给视频打赏失败!',
        descriptionL1: '你可以打开Youtube/Bilibili/腾讯视频应用',
        descriptionL2: '分享您感兴趣的视频到这里',
        descriptionL3: '分享您感兴趣的Youtube/Bilibili/腾讯视频到这里',
        descriptionL4: '分享视频',
        notLogin: '无法分享该视频，您尚未登陆。',
        balance: '视频花瓣数量',
        smallGift: '小礼',
        middleGift: '中礼',
        bigGift: '大礼',
        smallPresentTips: '赠送小礼后，视频的排名可能会提升',
        middlePresentTips: '赠送中礼后，视频的排名可能会提升',
        bigPresentTips: '赠送大礼后，视频的排名会排到第一',
        videoGotPetal: '此视频已获得了',
        videoOffline: '由于视频已经下架，该视频无法播放。',
        chatRoom: '聊天室',
        publish: '发布',
        me: '我',
        episode: '全一集'
    },
    label: {
        all: '全部',
        video: '视频',
        tvseries: '电视剧',
        movie: '电影',
        entertainment: '综艺娱乐',
        ent: '综艺',
        category: '类别',
        soundTrackLanguage: '音频语言',
        subtitleLanguage: '字幕语言',
        listTitle: '影片类型',
        listLanguageTitle: '影片音频',
        listSubtitle: '字幕'
    },
    subtitle: {
        setStart: '设置开始时间',
        setEnd: '设置结束时间',
        startTime: '开始时间',
        endTime: '结束时间',
        editNotLogin: '您尚未登陆，无法编辑字幕。请先登陆！',
        endEarlier: '结束时间不能早于开始时间',
        updateSucc: '更新字幕成功',
        updateFailed: '更新字幕失败'
    },
    share: {
        shareError: '无法分享到该应用程序(可能是由于您没有安装该应用程序)',
        supportedVideoSource: '支持的视频源',
        shareVideo: '分享视频',
        shareTo: '分享到',
        shareBy: '分享者',
        shareAt: '分享于',
        noCategory: '未选择类别',
        noLanguage: '未选择语言',
        tvsNotPlaylist: '电视剧类型必须是播放列表，单独视频请设置为“视频”类型',
        videoURL: '视频链接',
        wechatQrcode: '微信扫一扫分享',
        websiteShare: '将视频贴到博客或论坛',
        rewardExistedL1: '这个视频之前已经被过，分享人是',
        rewardExistedL2: '因为这个视频的花瓣数量不为正数，所以视频不会出现在展示列表中。',
        rewardExistedL3: '您可以打赏这个视频。如果您不喜欢这个视频，您可以输入一个负值减少视频花瓣数量，余额为负的视频不会展示在视频列表当中。',
        dislikeVideo: '如果您不喜欢这个视频，您可以花费相应数量的花瓣来减少视频花瓣值，为负的视频不会展示在视频列表当中。',
        bilibiliNotSupportSuchShare: 'Bilibili目前不支持链接含bangumi的此类型视频的分享，请重新选择要分享的视频链接',
        bilibiliCategory: 'Bilibili只允许分享”视频“或者”娱乐“类型，请将类别设置为“视频"或者"娱乐”类型!',
        youtubeInvalidUrl: '非可分享的Youtube视频连接',
        tencentInvalidUrl: '非可分享的腾讯视频连接',
        videoAddress: '视频地址',
        selectCategory: '选择分类',
        selectLanguage: '选择语言',
        selectSubtitle: '选择字幕',
        text1: '视频分类',
        text2: '配音语言',
        text3: '字幕语言'
    },
    account: {
        balance: '您的花瓣余额',
        facebookLoginFailed: '通过Facebook登陆失败!',
        lineLoginFailed: '通过Line登陆失败!',
        twitterLoginFailed: '通过Twitter登陆失败!',
        getTwitterProfileFailed: '获取Twitter 个人信息失败!',
        wechatLoginFailed: '通过微信登陆失败!',
        wechatNotInstalled: '未安装微信!',
        wechatLoginPrompt: '请在微信中打开该网址!',
        getAccessTokenFailed: '获取access token失败!',
        nextRewardTimeLeft: '距离下一次每日奖励还剩',
        insufficientPetal: 'Petal余额不足(需要花费{cost}花瓣，但您只有{balance}花瓣)',
        canPickupReward: '您现在可以领取奖励了！'
    },
    guide: {
        title: '新手指引',
        loginTitle: '如何登陆',
        loginMobileTitle: '登录',
        loginText1: '1、打开网页，上方会显示一段话，说明您未登录，点击登陆按钮；',
        loginText2: '2、点击登陆按钮后，显示的页面如下，可以选择其中任意一个登陆；如果之前手机或者电脑有登陆Facebook或者line就会直接跳转；',
        loginText3: '点击line登陆就会显示如下画面；',
        loginText4: '点击Facebook就会显示如下画面；',
        loginText5: '3、登陆之后，就会在右上角看到您的个人信息；点击人像就会显示下方的功能列表，有账户现有的花瓣数，每日奖励，邀请，发送反馈，语言设置，关于我们，以及登出。',
        shareTitle: '如何分享视频',
        shareMobileTitle: '分享视频',
        shareSubTitle1: '【网页端分享】',
        shareSubTitle2: '【手机端分享】',
        shareText1: '1、首先打开YouTube/Bilibili/腾讯视频，找到你想分享的视频，点击复制上面的网址；',
        shareText2: '2、返回petal网站，页面中会有一个share的按钮；如图',
        shareText3: '3、点击share按钮，就会弹出一下页面，系统会自动抓取您粘贴板上的网址；根据类别和语言选择匹配的内容即可，最后点击share，出现下方图二的提示语就是分享成功了。',
        shareText4: '1、首先打开YouTube应用程序，找到你想分享的视频，点击分享按钮，如图',
        shareText5: '2、在弹出来的页面中会有一个Petal的图标，如图',
        shareText6: '3、点击Petal图标后，Petal应用程序会自动打开并跳转到如下页面，系统会自动抓取您粘贴板上的网址；根据类别和语言选择匹配的内容即可，最后点击分享，出现下方图二的提示语就是分享成功了。',
        ruleTitle: '规则和单位介绍',
        ruleMobileTitle: '规则',
        ruleText: '【规则介绍】\n普通用户每日登陆可领取花瓣最多500K(根据账户活跃度以及随机配额分配，观看、打赏、分享视频都会增加活跃度），通过邀请链接成为用户的账号将会有20%额外每日奖励（即最多600K）；在个人页面的每日奖励领取；可以对所有视频进行打赏，打赏的花瓣来自于每日登陆领取的花瓣，以及邀请用户获得的奖励；\n打赏分为小礼、中礼、大礼；给他人打赏的小礼是2K/次，中礼是20K/次，大礼是200K/次（其中75%的奖励会打赏给分享视频的用户），打赏将可能会改变视频的排序（打赏大礼视频将会在该分类的最前显示）；\n可以对所有视频进行不喜欢点击，一旦该视频处于负分状态就不在网页上显示（点击不喜欢也是需要投入花瓣积分的，积分可以自己输入，比如1个或者1000个Petal）。\n\n【单位换算】\n最小单位Petal\n1 K = 1000 Petal\n1 M = 1000 K = 1000000 Petal'
    },
    error: {
        msg200: '创建用户失败',
        msg201: '未支持的第三方登录',
        msg203: '微信授权登录已取消',
        msg204: 'Line授权登录已取消',
        msg205: '获取访问令牌失败',
        msg206: '认证Line令牌失败',
        msg404: '页面不存在',
        msg999: '系统维护中，请稍后再试。如有不便请见谅！',
        backHome: '返回首页',
        alreadyShared: '复制链接视频已经被分享'
    },
    navText: {
        placeholder: '输入你想要搜索的内容',
        search: '搜索',
        share: '分享视频',
        sign: '签到赚花瓣',
        mine: '个人中心',
        loginPanelTitle: '登陆以后可以',
        loginPanelText1: '签到拿花瓣',
        loginPanelText2: '分享视频',
        loginPanelText3: '评论影片',
        loginPanelBtnText: '立即登陆',
        signText: '签到',
        select: '筛选'
    },
    shareCategory: [
        {
            label: '电视剧',
            value: 'tvseries'
        },
        {
            label: '电影',
            value: 'movies'
        },
        {
            label: '综艺娱乐',
            value: 'entertainment'
        },
        {
            label: '其他',
            value: 'other'
        }
    ],
    shareSound: [
        {
            label: '英文',
            value: 'english'
        },
        {
            label: '中文(普通话)',
            value: 'mandarin'
        },
        {
            label: '中文(广东话)',
            value: 'cantonese'
        },
        {
            label: '其他/无',
            value: 'other'
        }
    ],
    shareLanguage: [
        {
            label: '英文',
            value: 'english'
        },
        {
            label: '简体中文',
            value: 'simplified_chinese'
        },
        {
            label: '繁體中文',
            value: 'traditional_chinese'
        },
        {
            label: '其他/无',
            value: 'other'
        }
    ],
    shareSubCategoryMovie: [
        {
            label: '喜剧',
            value: 'comedy'
        },
        {
            label: '爱情',
            value: 'love'
        },
        {
            label: '动作',
            value: 'action'
        },
        {
            label: '犯罪',
            value: 'crime'
        },
        {
            label: '青春',
            value: 'youth'
        },
        {
            label: '悬疑',
            value: 'crux'
        },
        {
            label: '其他',
            value: 'other'
        }
    ],
    shareSubCategoryTVseries: [
        {
            label: '古装',
            value: 'costume'
        },
        {
            label: '偶像',
            value: 'idol'
        },
        {
            label: '青春',
            value: 'youth'
        },
        {
            label: '都市',
            value: 'city'
        },
        {
            label: '悬疑',
            value: 'crux'
        },
        {
            label: '喜剧',
            value: 'comedy'
        },
        {
            label: '家庭',
            value: 'family'
        },
        {
            label: '网络剧',
            value: 'internet'
        },
        {
            label: '其他',
            value: 'other'
        }
    ],
    shareSubCategoryEntertainment: [
        {
            label: '脱口秀',
            value: 'talk show'
        },
        {
            label: '访谈',
            value: 'interview'
        },
        {
            label: '亲子',
            value: 'parent-child'
        },
        {
            label: '美食',
            value: 'food'
        },
        {
            label: '文化',
            value: 'culture'
        },
        {
            label: '音乐',
            value: 'music'
        },
        {
            label: '舞蹈',
            value: 'dance'
        },
        {
            label: '财经',
            value: 'Finance'
        },
        {
            label: '其他',
            value: 'other'
        }
    ],
    shareSubCategoryOther: [
        {
            label: '其他',
            value: 'other'
        }
    ],
    newTextForm: {
        twiLogin: 'Twitter账号登陆',
        facebookLogin: 'Facebook账号登陆',
        wechatLogin: '微信登陆',
        lineLogin: 'LINE账号登陆',
        loginBottomText: '登陆即代表同意',
        userXieyi: "'用户协议'",
        and: '和',
        yinsiXieyi: "'隐私协议'",
        invateRule: '邀请规则',
        copyInvateLink: '复制邀请链接',
        copyTip: '复制你想要分享的链接在这'
    }
}



// WEBPACK FOOTER //
// ./src/language/locales/cn.js